import { Component } from 'react';
import { reportError } from '../services/telemetry';

/** App-level crash guard: reports the error, offers a reload. */
export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    reportError({
      message: error?.message || 'Render error',
      stack: error?.stack,
      url: window.location.pathname,
      type: 'react-boundary',
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-dvh items-center justify-center bg-panel px-4">
        <div className="w-full max-w-md rounded-card border border-line bg-white p-8 text-center shadow-card">
          <h1 className="font-display text-2xl font-extrabold tracking-tight">
            Something went wrong
          </h1>
          <p className="mt-2 text-sm text-inksoft">
            An unexpected error occurred. Reloading usually fixes it.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 rounded-full bg-brand px-6 py-2.5 text-sm font-bold text-white hover:bg-brand-dark">
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
